import { apiGet, apiPatch, apiPost, authorizedHeaders, type ApiGetOptions } from './client';
import type { AccessPolicy, SessionInfo, UserInfo } from '../types/auth';

export type LoginResponse = {
  token: string;
  user: UserInfo;
  policy?: AccessPolicy | null;
  session?: SessionInfo | null;
};

export async function login(email: string, password: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/login', { email, password });
}

export async function acceptInvite(token: string, password: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/invite/accept', { token, password });
}

export async function fetchInvitePreview(token: string): Promise<{ email: string; name?: string | null; expiresAt: string }> {
  return apiGet<{ email: string; name?: string | null; expiresAt: string }>(`/auth/invite/${encodeURIComponent(token)}`);
}

export async function requestPasswordReset(email: string): Promise<{ ok: boolean; message?: string }> {
  return apiPost<{ ok: boolean; message?: string }>('/auth/password/reset/request', { email });
}

export async function confirmPasswordReset(token: string, password: string): Promise<LoginResponse> {
  return apiPost<LoginResponse>('/auth/password/reset/confirm', { token, password });
}

export async function fetchMe(token: string): Promise<{ user: UserInfo; policy?: AccessPolicy | null; session?: SessionInfo | null }> {
  return apiGet<{ user: UserInfo; policy?: AccessPolicy | null; session?: SessionInfo | null }>('/auth/me', authorizedHeaders(token));
}

export async function fetchPolicy(token: string, options?: ApiGetOptions): Promise<{ user: UserInfo; policy?: AccessPolicy | null; session?: SessionInfo | null }> {
  return apiGet<{ user: UserInfo; policy?: AccessPolicy | null; session?: SessionInfo | null }>('/auth/policy', authorizedHeaders(token), options);
}

export async function updateUserPreferences(preferences: {
  preferredTheme: 'light' | 'dark';
}): Promise<{ preferences: { preferredTheme: 'light' | 'dark' }; user?: UserInfo; policy?: AccessPolicy | null; session?: SessionInfo | null }> {
  return apiPatch('/auth/preferences', preferences);
}
